import React from 'react';
import { motion } from 'framer-motion';
export function Discover() {
  return <div className="pt-32 pb-24 min-h-screen bg-brand-50" data-id="element-250">
      <div className="max-w-7xl mx-auto px-6" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="max-w-3xl" data-id="element-252">
          <h1 className="text-5xl font-serif text-charcoal-900 mb-6" data-id="element-253">
            Discover PlaneSmart
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed mb-12" data-id="element-254">
            Founded on the principles of safety, transparency, and unparalleled
            service, PlaneSmart has been redefining private aviation for over
            two decades.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-255">
          <motion.img initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2
        }} src="https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=1200&auto=format&fit=crop" alt="PlaneSmart Team" className="rounded-2xl shadow-xl" data-id="element-256" />
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} className="space-y-6 text-gray-600" data-id="element-257">
            <p data-id="element-258">
              Our mission is simple: Charter Simplified. We believe that flying
              private should be an effortless experience from the moment you
              request a quote to the moment you arrive at your destination.
            </p>
            <p data-id="element-259">
              With a diverse fleet of meticulously maintained aircraft and a
              team of seasoned aviation professionals, we offer a comprehensive
              suite of services tailored to the unique needs of our clients.
            </p>
          </motion.div>
        </div>
      </div>
    </div>;
}